export async function load_popover_polyfill() {
  const is_popover_supported = typeof HTMLElement !== "undefined" 
    && typeof HTMLElement.prototype === "object" 
    && "popover" in HTMLElement.prototype;
    
  if (!is_popover_supported) {
    console.log('Loading popover polyfill...');
    await import('./popover.js');
  }
}